import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { setUser, setIsAuthenticated } = useAuth();

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session data
        const response = await axios.get(`${API}/auth/session`, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true
        });

        const userData = response.data;
        setUser(userData);
        setIsAuthenticated(true);

        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true,
          state: { user: userData }
        });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { 
          replace: true,
          state: { error: 'Authentifizierung fehlgeschlagen. Bitte versuche es erneut.' }
        });
      }
    };

    processSession();
  }, [location.hash, navigate, setUser, setIsAuthenticated]);

  return (
    <div className="auth-callback-loading">
      <div className="auth-spinner"></div>
      <p>Anmeldung wird verarbeitet...</p>
    </div>
  );
};

export default AuthCallback;
